import mergeGradesWithOverride from './mergeGradesWithOverride';

const filterGradesWithErrors = ({
  grades = [],
  errors,
  hasStudentErrors,
  isJobFailed,
  overrides = [],
}) => {
  const errorGrades =
    !hasStudentErrors && isJobFailed
      ? grades
      : grades.reduce((allGrades, grade) => {
          const gradeError = errors.find(
            ({ studentId }) => studentId === grade.studentId
          );

          if (gradeError) {
            return [...allGrades, { ...gradeError, ...grade }];
          }
          return allGrades;
        }, []);

  return errorGrades.map(mergeGradesWithOverride(overrides));
};

export default filterGradesWithErrors;
